interface FormatCurrencyProps {
  amount: number;
}

export const formatCurrency = ({ amount }: FormatCurrencyProps): string => {
  const lang = localStorage.getItem('language') || 'en';

  let locale = 'en';

  if (lang === 'tr') {
    locale = 'tr-TR';
  } else if (lang === 'fi') {
    locale = 'fi-FI';
  } else {
    locale = 'en-US';
  }

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

interface FormatPercentageProps {
  value: string;
}

export const formatPercentage = ({ value }: FormatPercentageProps): string => {
  const locale = localStorage.getItem('language') || 'en';

  const afterNumberLocales = ['fi', 'en']; // Fince için yüzde işareti sonra

  if (afterNumberLocales.includes(locale)) {
    return `${formatCurrency({ amount: Number(value) })} %`;
  } else {
    return `%${formatCurrency({ amount: Number(value) })}`;
  }
};
